export default __webpack_public_path__ + "static/media/aboutUs2.3c41f403.webp";